import httpClient from '../../httpClient';
import { DataRoomNode } from 'router/subrouters/DataRoom/models/DataRoomNode';
import { DataRoomMemberNodes } from 'router/subrouters/DataRoom/models/DataRoom';
import { SoftSignalPayload } from 'models/Lead';
import { DataRoomFileBufferPreview } from 'models/File';

function getFileBufferPreview(nodeId: string, activeNode = true) {
  return httpClient.get<DataRoomFileBufferPreview>(
    `data-room-${
      activeNode ? 'nodes' : 'node-versions'
    }/${nodeId}/file-buffer-preview`,
  );
}

function startDownloadingFile(
  nodeId: string,
  uniqueId: string,
  activeNode = true,
) {
  return httpClient.get(
    `data-room-${
      activeNode ? 'nodes' : 'node-versions'
    }/${nodeId}/file-buffer-download`,
    {
      params: { uniqueId },
    },
  );
}

function getFolderPath(dataRoomId: string, documentId: string) {
  return httpClient.get<Array<DataRoomNode>>(
    `data-room-nodes/${documentId}/data-rooms/${dataRoomId}/node-path`,
  );
}

function getChildrenForMember(
  dataRoomId: string,
  parentId: string,
  dataRoomMemberId: string,
) {
  return httpClient.get<DataRoomMemberNodes>(
    `data-room-nodes/data-rooms/${dataRoomId}/member-parent-nodes`,
    {
      params: { parentId, dataRoomMemberId },
    },
  );
}

function softSignals(dataRoomNodeId: string, data: SoftSignalPayload) {
  return httpClient.post(`data-room-nodes/${dataRoomNodeId}/soft-signal`, data);
}

export default {
  getFileBufferPreview,
  startDownloadingFile,
  getChildrenForMember,
  getFolderPath,
  softSignals,
};
